import { cx } from "@jugl-web/utils";
import { FC, ReactNode } from "react";

export interface LiveChatUIContentProps {
  children: ReactNode;
  className?: string;
}

export const LiveChatUIContent: FC<LiveChatUIContentProps> = ({
  children,
  className,
}) => (
  <main
    className={cx(
      "relative flex min-w-0 flex-1 flex-col overflow-hidden bg-white",
      className
    )}
  >
    {children}
  </main>
);
